import React from 'react'
import PageTitle from '../PageTitle'


const Header = ({pageTitle}) => {
    return (

        <div className="d-flex flex-column flex-md-row justify-content-between align-items-end">
            {/* Profile Image */}
            <img
                src="/images/profile-picture.png"
                alt="Profile"
                className="profile-img border border-2 border-accent my-3"
            />
            <h1 className="text-accent">
            Hello, World!<span className="blinking-cursor">|</span>
          </h1>
            {/* Download Resume Button */}
            <a
                href="https://docs.google.com/document/d/1fOvZ72mEYGntN5BTuUv2EXjChfkZvsDi6KFntkuznWU/edit?usp=sharing"
                className="btn btn-outline-accent text-accent my-3"
                download
            >
                download resume
            </a>
        </div>

    )
}

export default Header